import { type ReactNode } from "react";
import clsx from "clsx";

import styles from "./badge.module.css";

export type BadgeVariant = "success" | "warning" | "danger" | "neutral";

export interface BadgeProps {
  children: ReactNode;
  variant?: BadgeVariant;
  /** Small colored circle shown before the label. */
  dot?: boolean;
  className?: string;
}

function variantClass(variant: BadgeVariant): string {
  switch (variant) {
    case "success":
      return styles.success;
    case "warning":
      return styles.warning;
    case "danger":
      return styles.danger;
    case "neutral":
    default:
      return styles.neutral;
  }
}

export function Badge({
  children,
  variant = "neutral",
  dot = false,
  className,
}: BadgeProps) {
  return (
    <span className={clsx(styles.badge, variantClass(variant), className)}>
      {dot ? <span className={styles.dot} aria-hidden /> : null}
      {children}
    </span>
  );
}
